(function () {
  if (window.__noonInit) return;
  window.__noonInit = true;

  function press(group, btn) {
    group.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  }

  /* Caffeine calculator */
  function initCalc(root) {
    if (root.__nn) return; root.__nn = true;
    var mg = parseFloat(root.dataset.mg) || 95;
    var ratio = (parseFloat(root.dataset.ratio) || 50) / 100;
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-cups]'));
    var out = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    function update(cups) {
      var reg = Math.round(cups * mg), noon = Math.round(reg * ratio);
      out('reg').textContent = reg;
      out('noon').textContent = noon;
      out('week').textContent = ((reg - noon) * 7).toLocaleString();
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { press(btns, b); update(parseInt(b.dataset.cups, 10)); });
    });
    var start = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    update(start ? parseInt(start.dataset.cups, 10) : 2);
  }

  /* Order finder */
  function initFinder(root) {
    if (root.__nn) return; root.__nn = true;
    var btns = Array.prototype.slice.call(root.querySelectorAll('.nn-opt'));
    var box = root.querySelector('[data-out="rec-box"]');
    var txt = root.querySelector('[data-out="rec"]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () { press(btns, b); txt.textContent = b.dataset.rec; box.hidden = false; });
    });
  }

  /* Subscription builder */
  function initSub(form) {
    if (form.__nn) return; form.__nn = true;
    var roasts = Array.prototype.slice.call(form.querySelectorAll('.nn-roast'));
    var bags = Array.prototype.slice.call(form.querySelectorAll('[data-bags]'));
    var radios = Array.prototype.slice.call(form.querySelectorAll('[data-nn-plans] input[type=radio]'));
    var out = function (k) { return form.querySelector('[data-out="' + k + '"]'); };
    var cta = out('cta'), msg = out('msg');
    var state = {
      roast: roasts.filter(function (r) { return r.getAttribute('aria-pressed') === 'true'; })[0] || roasts[0],
      bags: parseInt(form.dataset.popular, 10) || 2,
      plan: 'sub'
    };
    function render() {
      var r = state.roast;
      if (!r) return;
      var hasPlan = !!r.dataset.plan;
      var subRow = form.querySelector('[data-plan-row="sub"]');
      subRow.hidden = !hasPlan;
      if (!hasPlan) { state.plan = 'once'; radios.forEach(function (x) { x.checked = x.value === 'once'; }); }
      out('sub-price').textContent = r.dataset.subPrice || '';
      out('once-price').textContent = r.dataset.oncePrice || '';
      var word = state.bags === 1 ? '1 bag' : state.bags + ' bags';
      var available = r.dataset.available === 'true';
      cta.disabled = !available;
      cta.textContent = !available ? 'Sold out' : (state.plan === 'sub' ? 'Subscribe — ' : 'Add to Cart — ') + word + ' of ' + r.dataset.name;
    }
    roasts.forEach(function (r) { r.addEventListener('click', function () { press(roasts, r); state.roast = r; render(); }); });
    bags.forEach(function (b) { b.addEventListener('click', function () { press(bags, b); state.bags = parseInt(b.dataset.bags, 10); render(); }); });
    radios.forEach(function (x) { x.addEventListener('change', function () { if (x.checked) { state.plan = x.value; render(); } }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = state.roast; if (!r) return;
      var item = { id: parseInt(r.dataset.variant, 10), quantity: state.bags };
      if (state.plan === 'sub' && r.dataset.plan) item.selling_plan = parseInt(r.dataset.plan, 10);
      cta.disabled = true; msg.textContent = 'Adding…';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; })
        .catch(function (err) { msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; cta.disabled = false; });
    });
    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nn-calc]').forEach(initCalc);
    (scope || document).querySelectorAll('[data-nn-finder]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-nn-sub]').forEach(initSub);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
